import { Typography } from "@mui/material";
import { CreateSupportTicketMetaService } from "../../../app/backendTypes";

export default function SupportServiceDisplay(props: {
  service: CreateSupportTicketMetaService;
}) {
  const { service } = props;

  return (
    <>
      <Typography>
        <Typography component="span" color="text.secondary">
          Service:{" "}
        </Typography>
        {service.name}
      </Typography>
      <Typography>
        <Typography component="span" color="text.secondary">
          Team:{" "}
        </Typography>
        {service.team}
      </Typography>
    </>
  );
}
